export const trackReferralCandyPurchase = (orderData) => {
  if (typeof window !== 'undefined' && window.ReferralCandy) {
    try {
      window.ReferralCandy.track('purchase', {
        order_id: orderData.orderId,
        order_number: orderData.orderNumber,
        subtotal: orderData.subtotal,
        currency: orderData.currency || 'USD',
        customer_email: orderData.customerEmail,
        customer_first_name: orderData.customerFirstName,
        customer_last_name: orderData.customerLastName,
        timestamp: new Date().toISOString()
      });
      
      console.log('ReferralCandy purchase tracked:', orderData.orderId);
    } catch (error) {
      console.error('Error tracking ReferralCandy purchase:', error);
    }
  } else {
    setTimeout(() => {
      trackReferralCandyPurchase(orderData);
    }, 1000);
  }
};

export const trackReferralCandySignup = (customerData) => {
  if (typeof window !== 'undefined' && window.ReferralCandy) {
    try {
      window.ReferralCandy.track('signup', {
        customer_email: customerData.email,
        customer_first_name: customerData.firstName,
        customer_last_name: customerData.lastName,
        timestamp: new Date().toISOString()
      });
      
      console.log('ReferralCandy signup tracked:', customerData.email);
    } catch (error) {
      console.error('Error tracking ReferralCandy signup:', error);
    }
  }
};

export const getReferralParams = () => {
  if (typeof window === 'undefined') return null;
  
  const urlParams = new URLSearchParams(window.location.search);
  const referralParam = urlParams.get('ref') || urlParams.get('referral');
  
  if (referralParam) {
    return {
      referral_code: referralParam,
      referring_url: document.referrer || window.location.href
    };
  }
  
  return null;
};

export const storeReferralInfo = () => {
  const referralParams = getReferralParams();
  
  if (referralParams) {
    localStorage.setItem('referral_info', JSON.stringify({
      ...referralParams,
      timestamp: new Date().toISOString()
    }));
    
    console.log('Referral info stored:', referralParams);
    return referralParams;
  }
  
  return null;
};

export const getStoredReferralInfo = () => {
  if (typeof window === 'undefined') return null;
  
  try {
    const storedInfo = localStorage.getItem('referral_info');
    return storedInfo ? JSON.parse(storedInfo) : null;
  } catch (error) {
    console.error('Error parsing stored referral info:', error);
    return null;
  }
};

export const clearReferralInfo = () => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('referral_info');
    console.log('Referral info cleared');
  }
};

export const initReferralCandy = () => {
  storeReferralInfo();
  
  if (typeof window !== 'undefined' && window.ReferralCandy) {
    window.ReferralCandy.init({});
  }
};